module.exports = {
          srcSet: __webpack_public_path__ + "public/images/92e935ac6a7265182852754a86f0886f-380.jpg"+" 380w",
          images:[ {path: __webpack_public_path__ + "public/images/92e935ac6a7265182852754a86f0886f-380.jpg",width: 380,height: 253}],
          src: __webpack_public_path__ + "public/images/92e935ac6a7265182852754a86f0886f-380.jpg",
          toString:function(){return __webpack_public_path__ + "public/images/92e935ac6a7265182852754a86f0886f-380.jpg"},
          
          width: 380,
          height: 253
        }